import { AccountPage } from '@features/dashboard/specialistDashboard/specialistAccountSettings/specialistProfilePage';

export const AccountSettings = () => {
	return <AccountPage />;
};
